export const sectionBackgrounds = {
  hero: "https://images.pexels.com/photos/323705/pexels-photo-323705.jpeg?auto=compress&cs=tinysrgb&w=1600",
  services:
    "https://images.pexels.com/photos/834892/pexels-photo-834892.jpeg?auto=compress&cs=tinysrgb&w=1600",
  clients:
    "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=1600",
  projects:
    "https://images.pexels.com/photos/162539/architecture-building-amsterdam-blue-sky-162539.jpeg?auto=compress&cs=tinysrgb&w=1600",
  process:
    "https://images.pexels.com/photos/1216589/pexels-photo-1216589.jpeg?auto=compress&cs=tinysrgb&w=1600",
  about:
    "https://images.pexels.com/photos/416405/pexels-photo-416405.jpeg?auto=compress&cs=tinysrgb&w=1600",
  coverage:
    "https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg?auto=compress&cs=tinysrgb&w=1600",
  faq: "https://images.pexels.com/photos/7641824/pexels-photo-7641824.jpeg?auto=compress&cs=tinysrgb&w=1600",
  contact:
    "https://images.pexels.com/photos/1105766/pexels-photo-1105766.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

export const serviceCards = [
  {
    title: "Residential Construction",
    description:
      "Multi-storied residential buildings, independent homes, villas, and builder floors delivered with ISO 9001:2015 certified quality standards.",
  },
  {
    title: "Commercial Developments",
    description:
      "Office complexes, retail spaces, and multiplex developments with modern engineering techniques and international architectural partnerships.",
  },
  {
    title: "Turnkey Contracting",
    description:
      "Complete turnkey solutions from concept to execution, backed by experienced technical teams and systematic construction management.",
  },
  {
    title: "Institutional & Industrial Projects",
    description:
      "Specialized construction for institutional facilities and industrial structures with focus on efficiency and quality.",
  },
];

// Real completed projects
export const completedProjects = [
  {
    client: "SARE Homes",
    projectType: "Residential",
    location: "Ghaziabad",
    cost: "₹75 Cr",
    image: "/clients/work/sare.png",
  },
  {
    client: "Renox Group",
    projectType: "Commercial",
    location: "Ghaziabad",
    cost: "₹55 Cr",
    image: "/clients/work/renox.png",
  },
  {
    client: "Shubhanadam Builders",
    projectName: "ANANDAM FLOORS",
    projectType: "Residential",
    location: "Meerut",
    cost: "₹30 Cr",
    image: "/clients/work/anandam.png", // Using available image
  },
  {
    client: "Shri Group",
    projectType: "Residential",
    location: "Noida West",
    cost: "₹28 Cr",
    image: "/clients/work/shri-group.png",
  },
  {
    client: "GHMC",
    projectType: "Residential",
    location: "Hyderabad",
    cost: "₹24 Cr",
    image: "/clients/work/ghmc.png",
  },
  {
    client: "NBCC",
    projectType: "Residential",
    location: "Noida",
    cost: "₹22 Cr",
    image: "/clients/work/nbcc.png",
  },
  {
    client: "Nandini Homes",
    projectType: "Residential",
    location: "Ghaziabad",
    cost: "₹15 Cr",
    image: "/clients/work/nandini.png",
  },
];

// Client logos
export const prestigiousClients = [
  {
    name: "GHMC",
    fullName: "Greater Hyderabad Municipal Corporation",
    logo: "/clients/logos/ghmc.png",
    sector: "Government",
  },
  {
    name: "NBCC",
    fullName: "National Buildings Construction Corporation",
    logo: "/clients/logos/nbcc.png",
    sector: "Government",
  },
  {
    name: "Renox Group",
    logo: "/clients/logos/renox.png",
    sector: "Private",
  },
  {
    name: "Nandini Homes",
    logo: "/clients/logos/nandini.png",
    sector: "Private",
  },
  {
    name: "SARE Homes",
    logo: "/clients/logos/sare.png",
    sector: "Private",
  },
  {
    name: "Shri Group",
    logo: "/clients/logos/shri-group.png",
    sector: "Private",
  },
  {
    name: "Shubhanadam Builders",
    logo: "/clients/logos/shubhanadam.png",
    sector: "Private",
  },
];

export const processSteps = [
  {
    step: "01",
    title: "Site & Requirement Audit",
    detail:
      "We evaluate plot conditions, usage goals, timeline expectations and compliance needs with our experienced technical team.",
  },
  {
    step: "02",
    title: "Design & Technical Planning",
    detail:
      "Architectural design and engineering planning in partnership with internationally acclaimed architects, aligned to quality standards.",
  },
  {
    step: "03",
    title: "Execution & Quality Management",
    detail:
      "ISO 9001:2015 certified construction management with daily site supervision and modern engineering techniques.",
  },
  {
    step: "04",
    title: "Finishing & Handover",
    detail:
      "Quality verification, aesthetic finishing and complete handover support for ready occupancy with ongoing client satisfaction.",
  },
];

export const serviceAreas = [
  "Ghaziabad",
  "Noida",
  "Greater Noida",
  "Delhi NCR",
  "Meerut",
  "Nearby UP Regions",
];

// Company information
export const companyInfo = {
  founded: 2013,
  founder: "Mr. Vivek Sharma",
  certification: "ISO 9001:2015",
  projectsWorth: "₹100+ Crore",
  experience: "13+ Years",
};

// Vision & Mission
export const vision =
  "To be globally renowned as one of the best Engineering & Construction companies, continuing efforts to implement the latest techniques of engineering construction.";

export const mission =
  "To satisfy every client's need for a better experience in real estate with the help of a well-managed engineering team and close partnership with internationally acclaimed architects to achieve aesthetic, efficient and quality development.";

// About content
export const aboutText = `Devansh Buildsmore is an ISO 9001:2015 certified construction company established in 2013 as a sole proprietorship, headed by Mr. Vivek Sharma. With over 13 years of experience in the construction industry, we have successfully completed projects worth over ₹100 crores across NCR and nearby regions.

We specialize in multi-storied residential and commercial buildings, offering turnkey solutions from concept to execution. Our success is driven by an efficient and modern system of construction management backed by highly qualified technical personnel with substantial hands-on expertise.

Our reputation is built on excellence in providing comprehensive services - from initial concept through final execution - maintaining diligent professional standards while offering competitive pricing and timely delivery.`;
